var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.2,48.2H8.4c-0.6,0-1.1-0.5-1.1-1.1V8.5c0-3.6,2.9-6.5,6.5-6.5h22.2c3.6,0,6.5,2.9,6.5,6.5V47 C42.4,47.7,41.8,48.2,41.2,48.2z M9.5,45.9h30.5V8.5c0-2.3-1.9-4.2-4.2-4.2H13.7c-2.3,0-4.2,1.9-4.2,4.2V45.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.2,48.2H2.8c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h44.3c0.6,0,1.1,0.5,1.1,1.1C48.3,47.7,47.8,48.2,47.2,48.2z "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.1,48.2H18.9c-0.6,0-1.1-0.5-1.1-1.1v-7c0-2.1,1.7-3.8,3.8-3.8h6.9c2.1,0,3.8,1.7,3.8,3.8v7 C32.2,47.7,31.7,48.2,31.1,48.2z M20.1,45.9h9.8V40c0-0.8-0.7-1.5-1.5-1.5h-6.9c-0.8,0-1.5,0.7-1.5,1.5V45.9z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.2,13.6h-5.7c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h5.7c0.8,0,1.5,0.7,1.5,1.5S22,13.6,21.2,13.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.2,21.7h-5.7c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h5.7c0.8,0,1.5,0.7,1.5,1.5S22,21.7,21.2,21.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.2,29.8h-5.7c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h5.7c0.8,0,1.5,0.7,1.5,1.5S22,29.8,21.2,29.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.4,13.6h-5.7c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h5.7c0.8,0,1.5,0.7,1.5,1.5S35.2,13.6,34.4,13.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.4,21.7h-5.7c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h5.7c0.8,0,1.5,0.7,1.5,1.5S35.2,21.7,34.4,21.7z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.4,29.8h-5.7c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h5.7c0.8,0,1.5,0.7,1.5,1.5S35.2,29.8,34.4,29.8z"
  }))));
}

export default SvgBuilding;